import { Link } from "react-router-dom";

const Error404Mypage = () => {
  return (
    <div className="l-page-right">
      <div className="l-page-con">
        <h1 className="p-heading01">
          ご指定のページまたはファイルは見つかりませんでした
        </h1>
        <p className="p-404-img">
          <img src="/common/assets/images/404image_02.png" alt="" />
        </p>
        <label className="mb-5">
          「渋谷生涯活躍ネットワーク・シブカツ(通称：シブカツ)」サイトにアクセスしていただきありがとうございます。
          <br />
          大変申し訳ございませんが、該当するページが以下のような理由で存在しません。
        </label>
        <div className="li_box mt-5 mb-5">
          <li>すでに削除されて無効になっている。</li>
          <li>URLの入力やリンク先が間違っている、変更されている。</li>
          <li>一時的にアクセスが出来なくなっている。</li>
        </div>
        <div className="p-course-page__btn">
          <Link className="p-course-page__btn-link mt-5" to="../top">
            マイページトップへ戻る
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error404Mypage;
